<template>
  <div class="surveys-container">
    <h1>Umfragen</h1>
    <div class="search-container">
      <InputSearch placeholder="Suche" v-model="searchValue"></InputSearch>
      <p>Die Daten in der Tabelle aktualisieren sich aus Performancegründen nur alle 10 Minuten</p>
      <AdaButton title="NEUE UMFRAGE" type="createButton" to="/survey/create"
                 icon="icon-add"></AdaButton>
    </div>
    <AdaDatatable style="width: 100%;overflow-x: auto" :columns="columns" :data="rows" :show-pagination="true"
                  :search-value="searchValue" :transformers="transformers"
                  :size-of-page="10" @rowClicked="cellClicked"></AdaDatatable>
    <Dialog v-if="surveyToDelete" :show-close-button="true" :show="showDeleteDialog"
            :has-backdrop="true"
            @close="showDeleteDialog = false">
      <div class="delete-container">
        <h2>Module löschen</h2>
        <div style="margin-bottom: 30px">
          Soll die Umfrage: <span style="font-weight: bold">{{ this.surveyToDelete.name }}</span>
          wirklich
          gelöscht werden?
        </div>
        <AdaButton class="btn-delete" @click="deleteSurvey(surveyToDelete.id)" title="LÖSCHEN"
                   type="createButton"></AdaButton>
      </div>
    </Dialog>
    <Dialog v-if="downloading" :show="downloading"
            :has-backdrop="true">
      <div class="delete-container">
        <h2 text-align="center">Excel Report Download</h2>
        <div>
          Report wird erstellt. Der Download kann bis zu 5 Minuten dauern.
        </div>
        <div style="margin-top: 50px;display: flex;justify-content: center;align-content: center">
          <dot-loader></dot-loader>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>

import AdaDatatable from "../components/table/AdaDatatable";
import {RepositoryFactory} from "../scripts/RepositoryFactory";
import InputSearch from "../components/InputSearch";
import AdaButton from "../components/AdaButton";
import Dialog from "../components/Dialog";
import Transformers from "../components/table/Transformers";

const SurveysRepository = RepositoryFactory.get('surveys');

export default {
  name: "Surveys",
  components: {
    AdaDatatable,
    InputSearch,
    AdaButton,
    Dialog
  },
  data: function () {
    return {
      downloading: false,
      surveyToDelete: null,
      showDeleteDialog: false,
      searchValue: '',
      columns: [
        {
          viewName: 'ID',
          propName: 'id',
          sortable: true,
          sort: -1
        },
        {
          viewName: 'Name',
          propName: 'name',
          sortable: true
        },
        {
          viewName: 'Status',
          propName: 'status',
          sortable: true,
        },
        {
          viewName: 'Fortschritt (Test)',
          propName: 'progressTestGroup',
          sortable: true,
          width: '20%'
        },
        {
          viewName: 'Fortschritt (Kontroll)',
          propName: 'progressControlGroup',
          sortable: true,
          width: '20%'
        },
        {
          viewName: 'Gesehen/Markiert',
          propName: 'sawMarkedRatio',
          sortable: true,
        },
        {
          viewName: 'Beendet/Gesehen',
          propName: 'completedSawRatio',
          sortable: true,
        },
        {
          viewName: 'N',
          propName: 'test_size',
          sortable: true,
        },
        {
          viewName: 'Start',
          propName: 'date_start',
          sortable: true
        },
        {
          viewName: 'Ende',
          propName: 'date_end',
          sortable: true
        },
        {
          viewName: 'Aktionen',
          propName: 'actions'
        }
      ],
      rows: [],
      transformers: [
        {
          propName: 'actions',
          transform: function (value) {
            let res = '';
            value.forEach(action => {
              switch (action) {
                case 'edit':
                  res += '<span style="cursor: pointer" data-type="edit" class="margin-right-survey hover-highlight icon-edit"></span>';
                  break;
                case 'delete':
                  res += '<span style="cursor: pointer" data-type="delete" class="margin-right-survey hover-highlight icon-delete"></span>';
                  break;
                case 'report':
                  res += '<span style="cursor: pointer" data-type="report" class="margin-right-survey hover-highlight icon-dashboard"></span>';
                  break;
                case 'preview':
                  res += '<span style="cursor: pointer" data-type="preview" class="margin-right-survey hover-highlight icon-visible"></span>';
                  break;
                case 'download':
                  res += '<span style="cursor: pointer" data-type="download" class="margin-right-survey hover-highlight icon-download"></span>';
                  break;
              }
            });
            return res;
          }
        },
        {
          propName: 'date_start',
          transform: Transformers.dateTransformer
        },
        {
          propName: 'date_end',
          transform: Transformers.dateTransformer
        }, {
          propName: 'status',
          transform: function (value) {
            let res = value;
            switch (value) {
              case 'LIVE':
                res = '<span title="LIVE" style="color: rgb(215,4,101)" class="icon-status-live"></span>';
                break;
              case 'GEPLANT':
                res = '<span title="GEPLANT" style="color: rgb(215,4,101)" class="icon-status-inprogress"></span>';
                break;
              case 'BEENDET':
                res = '<span title="BEENDET" style="color: rgb(36,39,45)" class="icon-status-finished"></span>';
                break;
              case 'COMPLETE':
                res = '<span title="COMPLETE" style="color: rgb(80,80,200)" class="icon-apply"></span>';
                break;
            }
            return res;
          }
        },
        {
          propName: 'progressTestGroup',
          transform: function (value) {
            return `<div title="${value}%" style="position: relative;width: 100%; height: 20px;background-color: white"><div style="width: ${value}%; height: 20px;background: repeating-linear-gradient(45deg,#d70364,#d70364 5px,white 5px,white 10px);"></div></div>`;
          }
        },
        {
          propName: 'progressControlGroup',
          transform: function (value) {
            return `<div title="${value}%" style="position: relative;width: 100%; height: 20px;background-color: white"><div style="width: ${value}%; height: 20px;background: repeating-linear-gradient(45deg,#d70364,#d70364 5px,white 5px,white 10px);"></div></div>`;
          }
        },
        {
          propName: 'sawMarkedRatio',
          transform: function (value) {
            return value + '%';
          }
        },
        {
          propName: 'completedSawRatio',
          transform: function (value) {
            return value + '%';
          }
        }
      ]
    }
  },
  computed: {},
  methods: {
    async getSurveys() {
      const {data} = await SurveysRepository.getAll();
      for (let i = 0; i < data.length; i++) {
        data[i].actions = ['edit', 'delete', 'report', 'preview', 'download'];
      }
      this.rows = data;
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    cellClicked: async function (element) {
      let dataType = element.target.getAttribute('data-type');
      switch (dataType) {
        case 'edit': {
          await this.$router.push({name: 'editsurvey', params: {id: element.row.id}});
          break;
        }
        case 'delete': {
          this.surveyToDelete = element.row;
          this.showDeleteDialog = true;
          break;
        }
        case 'report': {
          await this.$router.push({name: 'report', params: {id: element.row.id}});
          break;
        }
        case 'preview': {
          let blMode = 'production';
          switch (process.env.NODE_ENV) {
            case 'dev':
              blMode = 'local';
              break;
            case 'stage':
              blMode = 'stage';
              break;
          }
          let urls = [
            'https://stern.de',
            'https://geo.de',
            'https://'
          ];
          window.open(`${urls[0]}?gujAd=1&blMode=${blMode}&blTest=1&blSurveyId=${element.row.id}`, '_blank').focus();
          break;
        }
        case 'download': {
          const {data} = await SurveysRepository.triggerDownload(element.row.id);
          let dlId = data.id;
          let finished = false;
          this.downloading = true;
          do {
            await this.sleep(3000);
            const {data} = await SurveysRepository.downloadStatus(dlId);
            console.log(finished);
            if (data.status === 'FINISHED' || data.status === 'ERRORED') {
              finished = true;
            }
            if (data.status === 'ERRORED') {
              this.$noty.error('Download failed');
            } else if (data.status === 'FINISHED') {
              let dlTries = 40;
              let dlSuccess = false;
              do {
                await this.sleep(500);
                try {
                  const {data} = await SurveysRepository.download(dlId);
                  dlSuccess = true;
                  const url = window.URL.createObjectURL(new Blob([data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', element.row.name + '_report.xlsx');
                  document.body.appendChild(link);
                  link.click();
                } catch (e) {
                  console.error(e);
                }
                dlTries--;
                if (dlTries <= 0) dlSuccess = true;
              } while (!dlSuccess);
            }
          } while (!finished);
          this.downloading = false;
          break;
        }
          /*        case 'download': {
                    const {data} = await SurveysRepository.download(element.row.id);
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', element.row.name + '_report.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    break;
                  }*/
        default: {
          await this.$router.push({name: 'editsurvey', params: {id: element.row.id}});
          break;
        }
      }
    },
    async deleteSurvey(surveyId) {
      await SurveysRepository.deleteSurvey(surveyId);
      this.showDeleteDialog = false;
      this.$noty.success('Die Umfrage wurde erfolgreich gelöscht');
      await this.getSurveys();
    }
  },
  mounted() {
    this.getSurveys();
  }
}
</script>
<style lang="scss" scoped>

.surveys-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
}

.search-container {
  width: 100%;
  background-color: white;
  height: 50px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
}

</style>